import { Dialog } from 'primereact/dialog';
import classes from './ExtenedNdcSuccessPopUp.module.scss';
import { Button } from 'primereact/button';
import { Player } from '@lottiefiles/react-lottie-player';
import successAnimation from 'assets/lottieFiles/successAnimation.json';

const ExtendedNdcSuccessPopup = ({
  visibility,
  toggleVisibility,
  addedFutureTmsData,
}: {
  visibility: boolean;
  toggleVisibility: () => void;
  addedFutureTmsData: { heading: string; value: string; startDate: string; endDate: string }[];
}) => {
  return (
    <Dialog
      blockScroll
      resizable={false}
      draggable={false}
      headerClassName={classes.modalHeader}
      header={'Extended NDC dates'}
      visible={visibility}
      style={{ width: '55vw', background: 'grey' }}
      onHide={() => {
        if (!visibility) return;
        toggleVisibility();
      }}
    >
      <div className={classes.newFutureTmsContainer}>
        <Player autoplay keepLastFrame className={classes.lottiePlayer} src={successAnimation} />
        {addedFutureTmsData.map((instance, index) => {
          return (
            <div className={classes.tableInstance} key={index}>
              <div className={classes.tableHeading}>
                {instance.heading === 'DP Strategy' ? 'Demand Planning' : instance.heading}
              </div>
              <table>
                <thead>
                  <tr>
                    <th>Value</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>{instance.value}</th>
                    <th>{instance.startDate}</th>
                    <th>{instance.endDate}</th>
                  </tr>
                </tbody>
              </table>
            </div>
          );
        })}

        <div className={classes.closeButtonDivWrapper}>
          <Button className={classes.closeButton} onClick={toggleVisibility}>
            Close
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ExtendedNdcSuccessPopup;
